import React from 'react'

export default React.createContext<'mobile' | 'desktop'>('desktop')
